import { ValidatorFn, UntypedFormArray, UntypedFormControl } from '@angular/forms';
import { CountryCode, parsePhoneNumber } from 'libphonenumber-js';

export class CustomValidators {

  static arrayMinLength(): ValidatorFn {
    return (group: UntypedFormArray): {[key: string]: any} | null => {
      return ((group as UntypedFormArray).controls.length === 0) ? { min: true } : null;
    };
  }

  static url(): ValidatorFn {
    return (control: UntypedFormControl): {[key: string]: any} | null => {
      const URL_REGEXP = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
      return (control.value === null || control.value === '' || URL_REGEXP.test(control.value)) ? null : {
        wrongUrl: {
          valid: false
        }
      };
    };
  }

  static email(): ValidatorFn {
    return (control: UntypedFormControl): {[key: string]: any} | null => {
      var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+$/i;
      return (control.value !== null && control.value !== '' && (control.value?.length <= 5 || !EMAIL_REGEXP.test(control.value))) ? { email: true } : null;
    };
  }

  static phone(country: CountryCode = 'DE'): ValidatorFn {
    return (control: UntypedFormControl): {[key: string]: any} | null => {
      if (control.value === null || control.value === '') {
        return null;
      }

      try {
        const phoneNumber = parsePhoneNumber(control.value, country);
        return phoneNumber.isValid() ? null : {
          wrongPhone: {
            valid: false
          }
        };
      } catch (error) {
        return {
          wrongPhone: {
            valid: false
          }
        };
      }
    };
  }

  static positiveNumberValidator(): ValidatorFn {
    return (control: UntypedFormControl): {[key: string]: any} | null => {
      if (control.value === null || control.value === '' || !isNaN(control.value)) {
        return null;
      }
      const value = control.value;
      const isValid = /^[0-9]+([,.][0-9]+)?$/.test(value) && parseFloat(value.replace(',', '.')) > 0;
      return isValid ? null : { positiveNumber: true };
    };
  }

}
